export default __webpack_public_path__ + "static/media/StellaM..3ee55b05.svg";